import ResponsiveStyleSheet from "react-native-media-query";
import { createResponsiveStyles, theme } from "@clearabee/ui-library-native";

export const { styles, ids } = ResponsiveStyleSheet.create({
  container: createResponsiveStyles({
    base: {
      padding: theme.spacing.medium,
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      backgroundColor: theme.colors.warning.base,
      flexDirection: "row",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      zIndex: 1,
    },
    large: {
      position: "absolute",
    },
  }),
  innerContainer: {
    flexWrap: "wrap",
    flex: 1,
  },
  doNotShowPrompt: createResponsiveStyles({
    base: {
      alignSelf: "flex-start",
      paddingTop: theme.spacing.xsmall,
    },
    large: {
      alignSelf: "flex-end",
    },
  }),
  tooltipMessage: {
    marginVertical: theme.spacing.xsmall2,
  },
});
